import { Box, Checkbox, IconButton, Typography } from '@mui/material';

import type { SearchPanelItem } from '../types';

import { ItemRowStyled } from './item-row.styled';

type ItemRowProps = {
  item: SearchPanelItem;
  selected: boolean;
  isLast: boolean;
  onToggle: () => void;
};

export const ItemRow = (props: ItemRowProps) => {
  const { item, selected, isLast, onToggle } = props;

  return (
    <ItemRowStyled selected={selected} isLast={isLast} onClick={onToggle}>
      <Checkbox size="small" checked={selected} readOnly sx={{ pointerEvents: 'none' }} />
      {item.icon && (
        <IconButton variant="pill" size="small" component="span">
          {item.icon}
        </IconButton>
      )}
      <Typography variant="body2" noWrap>
        {item.label}
      </Typography>
      {item.endAdornment && (
        <Box ml="auto" pl={1} flexShrink={0} display="flex" alignItems="center">
          {item.endAdornment}
        </Box>
      )}
    </ItemRowStyled>
  );
};
